<script>
import { addToAppleWallet, addToGoogleWallet } from '@api/ticket_management.service'
import {
  AnswerMessage,
} from '@utils/submit'
import {
  isIosSafari, isAndroid,
} from '@/js/firebase/helpers'

import {
  exportFileWithoutSave,
} from '@utils/file'

const ANDROID_PLATFORM = 'android'

export default {
  name: 'AddToWallet',
  props: {
    platform: {
      type: String,
      required: true,
    },
    identifier: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      load: false,
    }
  },
  methods: {
    async action() {
      if (this.platform === ANDROID_PLATFORM) {
        try {
          const { data } = (await addToGoogleWallet.execute({}, {
            platform: this.platform,
            identifier: this.identifier,
          }))
          if (data && data.google_pass_url) {
            window.location.href = data.google_pass_url
          }
          this.$notify({
            type: 'notify',
            title: `${this._('Квиток успішно додано до гаманця!')}`,
          })
        } catch (e) {
          this.load = false
          try {
            const { errors } = await e.json()
            const [error] = errors
            const [first] = error.state.non_field_errors
            const meta = {
              message: {
                header: first.message,
                title: first.message,
              },
            }
            AnswerMessage(meta, this)
          } catch (err) {
            console.error(err)
            this.$notify({
              type: 'error',
              title: `${this._('Помилка при додаванні квитка до гаманця!')}`,
            })
          }
        }
        return
      }
      const fileToExport = await exportFileWithoutSave(addToAppleWallet, {}, {
        platform: this.platform,
        identifier: this.identifier,
      })
      const a = document.createElement('a')
      a.href = fileToExport.url
      a.download = fileToExport.name
      a.type = 'application/vnd.apple.pkpass'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(fileToExport.url)
    },
  },
  render() {
    return this.$scopedSlots.default({
      add: this.action,
      load: this.load,
      isIosSafari: isIosSafari(),
      isAndroid: isAndroid(),
    });
  },
}
</script>
